import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  errorContainer: {
    border: `1px solid ${theme.palette.grey[400]}`,
    borderRadius: "14px",
    maxWidth: "26.25rem",
  },
}));
